module.exports = __webpack_public_path__ + "static/media/heart.77100eea.svg";